<app-spinner [(show)]="loading"></app-spinner>
<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content" *ngIf="!loading">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span class="esf-action-heading__text">{{ i18nHeading }}</span>
    </h1>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="currentReminders"
                         [actionButtons]="actionButtons"
                         (rowButtonClickEvent)="actionButtonClicked($event)"
                         (rowClickEvent)="openEditReminder($event)"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="createReminders($event)"

                         [emptyStateText]="i18nEmptyState"
                         [emptyStateIcon]="'#esf-icon-bell-32'">

    </app-paginated-table>

  </div>
</main>

<app-home-reminder-edit *ngIf="sidebarOpened"
                        [(sidebarOpened)]="sidebarOpened"
                        [authenticatedUser]="authenticatedUser"
                        [customer]="selectedCustomer">
</app-home-reminder-edit>
